import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

// third-party

// project imports
// import SubCard from 'ui-component/cards/SubCard';
import { SET_MODE } from 'store/actions';

// assets
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { IconMoon, IconSun } from '@tabler/icons-react';
import config from 'globalConfig';

// ==============================|| LIVE CUSTOMIZATION ||============================== //

const Customization = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);

    // drawer on/off
    const [open, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen(!open);
    };

    let initialMode;
    switch (customization.mode) {
        case 'dark':
            initialMode = true;
            break;
        case 'light':
        default:
            initialMode = false;
            break;
    }

    // state - font family
    const [darkMode, setDarkMode] = useState(initialMode);

    useEffect(() => {
        let newMode;
        if (darkMode) {
            newMode = 'dark';
        } else {
            newMode = 'light';
        }
        dispatch({ type: SET_MODE, mode: newMode });
        // set theme palette type
    }, [dispatch, darkMode]);

    return (
        <>
            {/* toggle button */}
            <FormControl
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    padding: '0 1rem'
                }}
            >
                <ToggleButtonGroup
                    value={darkMode ? 'dark' : 'light'}
                    exclusive
                    onChange={(e, mode) => setDarkMode(mode === 'dark')}
                    aria-label="theme mode"
                    defaultChecked={darkMode}
                >
                    <ToggleButton
                        sx={{ border: 'none !important', borderRadius: config.borderRadiusSm }}
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        value="dark"
                        aria-label="dark theme"
                    >
                        <IconMoon stroke={2} size="1.3rem" />
                    </ToggleButton>
                    <ToggleButton
                        sx={{ border: 'none !important', borderRadius: config.borderRadiusSm }}
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        value="light"
                        aria-label="light theme"
                    >
                        <IconSun stroke={2} size="1.3rem" />
                    </ToggleButton>
                </ToggleButtonGroup>
                {darkMode ? (
                    <Typography
                        variant="p"
                        sx={{ ml: 2, color: theme.palette.grey[300], fontWeight: 400, fontSize: '0.875rem', pt: '0 !important' }}
                    >
                        Dark mode
                    </Typography>
                ) : (
                    <Typography
                        variant="p"
                        sx={{ ml: 2, color: theme.palette.grey[300], fontWeight: 400, fontSize: '0.875rem', pt: '0 !important' }}
                    >
                        Light mode
                    </Typography>
                )}
            </FormControl>
        </>
    );
};

export default Customization;
